module.exports = __webpack_public_path__ + "img/nextStep.1d58ea3f.png";